class pageFormController {
  constructor($scope, $state, pageContentService, pageContentTransformer, messageService, access) {
    this.$scope = $scope;
    this.$state = $state;
    this.pageContentService = pageContentService;
    this.pageContentTransformer = pageContentTransformer;
    this.messageService = messageService;
    this.access = access;
  }

  $onInit() {
    if (this.page.sections && this.page.sections.options){
      if (this.page.sections.options.active && this.page.sections.options.active === 'true') {
        this.page.sections.options.active = 1;
      } else {
        this.page.sections.options.active = 0;
      }
    }
  }

  isSingleTextPageAdmin() {
    return this.access.check('admin') && [
      'privacy',
      'terms',
      'defaultcheckoutdays',
      'defaultoptions',
      'defaultsuggestions',
      'defaultpayment',
      'defaultreview',
      'defaultconfirmation'
    ].indexOf(this.pageDetails.slug) > -1;
  }

  isSingleTextPageManager() {
    return [
      'payment',
      'review',
      'announcement',
      'checkoutdays',
      'options',
      'confirmation',
      'suggestions',
      'manage-booking'
    ].indexOf(this.pageDetails.slug) > -1;
  }

  onSave () {
    return this.pageContentService.save(this.pageContentTransformer.fromJson(this.page))
      .then(() => {
        let target = (this.type ? `app.admin.globalPageContent-edit` : `app.admin.pageContent-edit`) + `({ 'page' : '${this.pageDetails.slug}'})`;
        if (this.page.updated_at) {
          this.messageService.success(`The <strong>${this.pageDetails.name}</strong> content was successfully updated!`, [
            target,
            `page`
          ]);
        } else {
          this.messageService.success(`The <strong>${this.pageDetails.name}</strong> content was successfully created.`, [
            target,
            `page`
          ]);
        }
      })
      .then(() => {
        this.messageService.clear();
        if (this.type) {
          switch (this.type) {
          case 'global':
          case 'admin':
            this.$state.go('app.admin.globalPageContent');
            return;
          case 'email':
            this.$state.go('app.admin.emailPageContent');
            return;
          }
        } else {
          this.$state.go('app.admin.pageContent');
        }
      })
      .catch((error) => {
        this.messageService.failure(`The page <strong>${this.page.name}</strong> could not be successfully created: ${error.statusText}`);
        this.messageService.push();
        var sourceElement = Object.keys(error.data)[0];
        if (sourceElement > 0) {
          this.$scope.$ctrl.form[sourceElement].$setValidity(sourceElement, false);
        } else {
          this.$scope.$ctrl.form.$setValidity(sourceElement, false);
        }
      });
  }
}

pageFormController.$inject = [ '$scope', '$state', 'pageContentService', 'pageContentTransformer', 'messageService', 'access' ];

export default pageFormController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/pageContent/controllers/pageContent.form.controller.js